import type { FilePreviewKind } from './FilePreviewKind';

const IMAGE_EXT = /\.(png|jpe?g|gif|webp|bmp|svg)$/;

/**
 * Чи можна переглянути файл у вікні (UIUX field-types/file: «Preview images and PDFs»): PDF — 'pdf', зображення — 'image', решта —
 * null (лише завантаження). Тип визначає MIME, а за його відсутності чи «application/octet-stream» — розширення імені. Чиста функція.
 */
export function previewKindOf(fileName: string, mimeType: string | null | undefined): FilePreviewKind | null {
  const mime = (mimeType ?? '').toLowerCase();
  const name = fileName.toLowerCase();
  if (mime === 'application/pdf') return 'pdf';
  if (mime.startsWith('image/')) return 'image';
  if (mime && mime !== 'application/octet-stream') return null;
  if (name.endsWith('.pdf')) return 'pdf';
  return IMAGE_EXT.test(name) ? 'image' : null;
}
